import React from 'react';
import './pdp-addons.scss';
import Icon from '../../mweb/Icon/Icon';
import SeeMore from '../SeeMore/SeeMore';

const VerticalAddon = ({ addon, desktop = false }) => {
  return (
    <div className="vertical-addon">
      {addon.name && <div className="vertical-addon--title">{addon.name}</div>}
      {addon.description && (
        <div className="vertical-addon--description">
          <SeeMore rows={3} lineHeight={desktop ? 24 : 22}>
            {addon.description}
          </SeeMore>
        </div>
      )}
      {addon.details.map((a, index) => {
        return (
          <div className="vertical-addon--addon" key={index}>
            <Icon
              size={desktop ? 90 : 77}
              src={a.imageURL}
              class="vertical-addon--addon--icon"
            />
            <div>
              <div className="vertical-addon--addon--title">{a.name}</div>
              <div className="vertical-addon--addon--description">
                {a.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VerticalAddon;
